import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const EmptyDashboard = () => {
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();

  return (
    <div className="page-container" style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center" }}>
      <div className="landing-topbar" style={{ position: "fixed", top: "10px", boxSizing: "border-box" }}>
          <img src="/logo-dark.svg" alt="logo" style={{width: "118px"}} />
        <div style={{ display: "flex", gap: "20px" }}>
          <button
            onClick={() => navigate(`/signup`)}
            style={{
              padding: "10px 24px",
              cursor: "pointer",
              background: "#2A6FFF",
              border: "none",
              color: "white",
              borderRadius: "90px",
              fontWeight: "bold",
             fontSize: "16px",
             margin: "auto"
            }}>
            Sign Up
          </button>
          <button
            onClick={() => navigate(`/login`)}
            style={{
              padding: "10px 24px",
              cursor: "pointer",
              background: "white",
              border: "1px solid rgba(255, 255, 255, 0.14)",
              color: "#19232f",
              borderRadius: "90px",
              fontSize: "16px",
              fontWeight: "bold",
                margin: "auto"
            }}>
            Login
          </button>
        </div>
      </div>
      <div className="main" style={{ padding: "0", width: "100%" }}>
        <div
          style={{
            position: "relative",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            backgroundImage: `url('/landing-bg.png')`,
            backgroundSize: "cover", // makes image cover entire div
            backgroundPosition: "center", // centers the image
            backgroundRepeat: "no-repeat", // prevents tiling
            padding: "40px 10px",
            minHeight: "50vh",
          }}>
          <img
            src="/player-group-1.png"
            alt="logo"
            style={{
              position: "absolute",
              left: "45%", // anchor to center
              bottom: 0,
              width: "440px",
              transform: "translateX(-620px)", // fixed offset from center
              pointerEvents: "none",
              zIndex: 0,
            }}
            className="landing-player-banner-XL"
          />
          <img
            src="/player-group-2.png"
            alt="logo"
            style={{
              position: "absolute",
              left: "56%", // anchor to center
              bottom: 0,
              width: "440px",
              transform: "translateX(180px)", // fixed offset from center
              pointerEvents: "none",
              zIndex: 0,
            }}
            className="landing-player-banner-XL"
          />
          <div style={{ position: "relative", zIndex: 2, textAlign: "center", justifyItems: "center", padding: "0 5px" }}>
            <img src="/logo.svg" alt="logo" style={{ height: "32px", marginBottom: "10px" }} />
            <h2 className="landing-title" style={{ margin: "14px 0 0 0" }}>
              LIVE THE FANTASY.
            </h2>
            <h2 className="landing-title" style={{ margin: "0 0 14px 0" }}>
              CLAIM THE GLORY.
            </h2>
            {/* <p
              style={{
                color: "white",
                letterSpacing: "-0.4px",
                margin: 0,
                opacity: 0.6,
                fontWeight: 500,
                maxWidth: 340,
                width: "100%",
                boxSizing: "border-box",
              }}>
              Build your dream lineup. When they shine, you win and earn rewards!
            </p> */}
            <div className="landing-player-banner">
              <img src="/player-group-1.png" alt="logo" />
              <img src="/player-group-2.png" alt="logo" />
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", marginTop: "30px" }}>
              <h3
                style={{
                  color: "white",
                  letterSpacing: "-0.4px",
                  margin: 0,
                  textShadow: "rgba(0, 0, 0, 0.6) 0px 0px 20px",
                  fontStyle: "italic",
                  fontWeight: "600",
                }}>
                START BUILDING YOUR LEGACY.<br></br>FREE TO PLAY.
              </h3>
            </div>
          </div>
        </div>
        {/* <div className="participating-leagues-container">
          <img src="/banners/LCK-banner.png" alt="LCK Banner" />
          <img src="/banners/LPL-banner-white.png" alt="LPL Banner" />
          <img src="/banners/LEC-banner.png" alt="LEC Banner" />
          <img src="/banners/LCP-banner-white.png" alt="LCP Banner" />
        </div> */}
        <div style={{ display: "flex", flexDirection: " column", gap: "80px", alignItems: "center", marginTop: 40 }}>
          <h2 style={{ color: "white", fontWeight: "900", fontSize: "32px", letterSpacing: "-1px", margin: "0", textAlign: "center" }}>
            BUILD YOUR ESPORTS LEGACY
          </h2>
          <div
            style={{
              // background: "#ffffff05",
              width: "100%",
              padding: "40px 10px",
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "40px",
            }}>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
              <h3
                style={{
                  color: "white",
                  letterSpacing: "-0.8px",
                  margin: 0,
                  textShadow: "rgba(0, 0, 0, 1) 0px 0px 20px",
                  fontSize: "36px",
                  fontWeight: "700",
                  textAlign: "center",
                }}>
                Think you have what it takes?
              </h3>
              <p style={{ margin: "0", color: "white", letterSpacing: "-0.8px", textAlign: "center" }}>Prove it. Win big prizes</p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                maxWidth: "600px",
              }}>
              <img
                src="/players/fear_diable_fs_preview.png"
                alt="Fear"
                style={{
                  width: "30%",
                  minWidth: "90px",
                  height: "auto",
                  transform: "translateX(20%)",
                  zIndex: 1,
                }}
              />

              <img
                src="/players/g2_caps_fs_preview.png"
                alt="Caps"
                style={{
                  width: "35%",
                  minWidth: "110px",
                  height: "auto",
                  zIndex: 2,
                }}
              />

              <img
                src="/players/wbg_xiaohu_full_preview.png"
                alt="Xiaohu"
                style={{
                  width: "30%",
                  minWidth: "90px",
                  height: "auto",
                  transform: "translateX(-20%)",
                  zIndex: 1,
                }}
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column", marginTop: "40px" }}>
              <h3
                style={{
                  color: "white",
                  letterSpacing: "-0.8px",
                  margin: 0,
                  textShadow: "rgba(0, 0, 0, 1) 0px 0px 20px",
                  fontSize: "36px",
                  fontWeight: "700",
                  textAlign: "center",
                }}>
                Earn your spot in the international stage!
              </h3>
              <p style={{ margin: "0", color: "white", letterSpacing: "-0.8px", textAlign: "center" }}>
                Win limited prizes and badges in the toughest challenge of them all
              </p>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src="/format.png" alt="First Stand G2 Caps" style={{ width: "100%", height: "auto", maxWidth: "800px", borderRadius: "8px" }} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EmptyDashboard;
